import { render, staticRenderFns } from "./UiRichTextEditor.vue?vue&type=template&id=6f1023b9"
import script from "./UiRichTextEditor.vue?vue&type=script&lang=ts"
export * from "./UiRichTextEditor.vue?vue&type=script&lang=ts"
import style0 from "./UiRichTextEditor.vue?vue&type=style&index=0&id=6f1023b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports